import { cn } from '@/lib/utils';

interface IIconProps {
  className: string;
  style?: React.CSSProperties;
}

function ChevronRightIcon({ className, style }: IIconProps) {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={cn(className)}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
    </svg>
  );
}

export default ChevronRightIcon;
